import React, { FC } from 'react';
import Svg from 'svg-inline-react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { Button } from '@src/components/Button';
import { UserProfileLinkTypeEnum } from '@src/graphql/generated';
import CloseSvg from '@src/svgs/fr-close-small.svg';
import { RootState } from '@src/redux/interfaces/redux.interface';
import { Tooltip } from '@src/components/Tooltip';
import { getCompany } from '@src/redux/selectors/company';
import { Save } from '../../Actions/Save';
import { Share } from '../../Actions/Share';
import { LinkedIn } from '../../Actions/LinkedIn';
import { Props } from './props';
import './styles.scss';

export const MESSAGE_MIN_LENGTH = 50;

const _Footer: FC<Props> = ({
  message,
  talent,
  modalOptions,
  isCompanyProfilePublished,
  onButtonClick,
  onLinkedInClick,
  onClose,
}) => {
  const hasRecruiterMessaged = !!talent.recruiterState.hasMessaged;
  const isUserVerified = !!talent.userVerification;
  const linkedIn = talent.user.profile.links.find(({ type }) => type === UserProfileLinkTypeEnum.LINKEDIN);
  const linkedInUrl = linkedIn?.value;

  const renderSendMessageButton = () => {
    if (!modalOptions?.shouldOnlyShowProfile) {
      if (isCompanyProfilePublished) {
        return (
          <Button isDisabled={message.length < MESSAGE_MIN_LENGTH} onClick={onButtonClick}>
            Send a message
          </Button>
        );
      } else {
        return (
          <Tooltip overlay="Please finish your Company profile before sending messages" placement="top">
            <Button
              className={classnames(!isCompanyProfilePublished && 'verify-talent-modal-footer__disable')}
              isDisabled={message.length < MESSAGE_MIN_LENGTH}
            >
              Send a message
            </Button>
          </Tooltip>
        );
      }
    } else {
      return null;
    }
  };

  return (
    <div className="verify-talent-modal-footer">
      <div className="verify-talent-modal-footer__close" onClick={onClose}>
        <Svg src={CloseSvg} />
        <span>Close</span>
      </div>
      <div className="verify-talent-modal-footer__actions">
        <LinkedIn
          hasRecruiterMessaged={hasRecruiterMessaged}
          isUserVerified={isUserVerified}
          linkedInUrl={linkedInUrl}
          onLinkedInClick={onLinkedInClick}
        />
        <Share copyText={window.location.href} isUserVerified={isUserVerified} />

        {!modalOptions?.shouldHideTalentSave && <Save user={talent.user} />}

        {renderSendMessageButton()}
      </div>
    </div>
  );
};

export const Footer = connect(
  (state: RootState) => ({
    isCompanyProfilePublished: getCompany(state)?.profile?.isPublished,
  }),
  null,
)(_Footer);
